<template>
  <AppButton
    v-bind="$attrs"
    variant="secondary"
    class="map-search-button whitespace-nowrap px-4 py-2 text-[1.1rem]"
    @click="$emit('click', $event)"
  >
    <span>{{ $t('Search this area') }}</span>
  </AppButton>
</template>

<script>
import AppButton from '@/components/buttons/AppButton.vue';

export default {
  name: 'MapSearchButton',
  components: {
    AppButton,
  },
  inheritAttrs: false,
  emits: ['click'],
};
</script>

<style scoped>
.map-search-button {
  font-size: 1.1rem;
  padding: 0.9rem 1.6rem;
  border-radius: 999px;
  border-color: #ffffff;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 18px rgba(193, 193, 193, 0.25);
}
</style>
